import axios from "axios";

/**
 * Download a PDF that sits behind an auth token (employer certificate / id card
 * / registration form, a student's application form, the council's copies).
 *
 * The document endpoints stream a PDF, so a plain <a href> cannot carry the
 * Authorization header - we fetch it as a blob and save it. Same API base the
 * rest of the bundle uses.
 */
const API =
  (typeof window !== "undefined" && window.__PLACEMENT_API__) ||
  "https://nsvec.com/api/public/api/";

/** Trigger a browser "save" for a blob. */
function saveBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

/**
 * GET or POST a PDF endpoint with a bearer token and save it.
 *   url      : path after the API base, e.g. "placement/employer/certificate"
 *   token    : bearer token (or "" for public endpoints)
 *   filename : saved file name
 *   method   : "get" (default) or "post"
 *   data     : body for POST (object)
 * Returns a promise; rejects on error so the caller can show a message.
 */
export async function downloadAuthedPdf(url, token, filename, method = "get", data = null) {
  const headers = {};
  if (token) headers.Authorization = "Bearer " + token;

  const res = await axios({
    url: API + url,
    method,
    data: method === "post" ? data : undefined,
    headers,
    responseType: "blob",
  });
  saveBlob(res.data, filename);
}
